import { Column } from 'typeorm';

import { ApiProperty } from '../../codegen';
import { EPartners } from '../../enums';
import { IsEnum, IsString, IsNumber, IsOptional } from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

export class SubscriptionPlan extends BasicEntity {
  @ApiProperty()
  @IsString()
  @Column({ type: 'varchar', nullable: false, default: '' })
  name: string;

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  projectsLimit: number; // number of projects available in the plan

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  coins: number; // coins included in the plan

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  days: number; // subscription extension days

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  price: number; // in cents for nimbia, in kopecks for oblako

  @IsNumber({}, { each: true })
  @Column({ type: 'int', array: true, nullable: true })
  accountIds?: number[]; // users who can select this plan; null means available to all users

  @ApiProperty()
  @IsOptional()
  @IsEnum(EPartners)
  @Column({ type: 'enum', enum: EPartners, nullable: true })
  partner?: EPartners; // partner plans stack with own plans (currently only one, from Elama)
  // at most one own plan and one partner plan can be active at the same time
}
